import { useMount } from 'ahooks';
import { Input, PageHeader, Space, Tabs } from 'antd';
import { useAppSelector } from 'app/hooks';
import { RevxButton } from 'components/RevxButton';
import { Title } from 'components/RevxTypography';
import { isPlatformOrg, Organization } from 'domains/orgDomain';
import { useOrg, useUser } from 'hooks';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import networkService from 'services/networkService';
import { isOrgAdmin, isSysAdmin } from 'utils/rbac';
import { NetworkJoinedTable } from './NetworkJoinedTable';
import { NetworkMemberTable } from './NetworkMemberTable';
import { MarketplaceNetworkMemberTable } from './MarketplaceNetworkMemberTable';

const NetworkAdmin = () => {
  const { t } = useTranslation();
  const members = useAppSelector((state) => state.network.members);
  const marketplaceNetworksForOrgId = useAppSelector(
    (state) => state.network.marketplaceNetworksForOrgId
  );
  const [searchValue, setSearchValue] = useState<string>('');
  const [addMember, setAddMember] = useState<boolean>(false);
  const [orgs, setOrgs] = useState<Organization[]>([]);
  const user = useUser();
  const contextOrg = useOrg();

  useMount(async () => {
    const res = await networkService.getAllNetworkOrgs(Number(user?.orgId));
    setOrgs(res);
  });

  const [tabKey, setTabKey] = useState<string>('1');

  return (
    <>
      <Tabs
        activeKey={tabKey}
        destroyInactiveTabPane={true}
        onChange={(key) => setTabKey(key)}
      >
        <Tabs.TabPane tab="Supplier connections" key="1">
          <PageHeader
            ghost={false}
            className="platform-page-header"
            title={
              <Space>
                <Title
                  style={{ marginBottom: 0, marginTop: 6, marginRight: 40 }}
                >
                  {members.length} Network Members
                </Title>
                <RevxButton
                  hidden={isOrgAdmin(user)}
                  brandGreen
                  onClick={() => {
                    setAddMember(!addMember);
                  }}
                >
                  {addMember
                    ? t('platform.network.viewMember')
                    : t('platform.network.addMember')}
                </RevxButton>
              </Space>
            }
            extra={[
              <Input.Search
                key="search"
                placeholder={t('platform.network.searchPlaceholder')}
                onChange={(e) => setSearchValue(e.target.value)}
                allowClear
                enterButton
                style={{ width: 400 }}
              />,
            ]}
          />
          <NetworkMemberTable
            orgs={orgs}
            searchValue={searchValue}
            addMember={addMember}
            onManageClick={() => setTabKey('3')}
          />
        </Tabs.TabPane>
        {isSysAdmin(user) && (
          <Tabs.TabPane tab="Manage Pricing Data" key="2">
            <NetworkJoinedTable orgs={orgs} />
          </Tabs.TabPane>
        )}
        {isSysAdmin(user) && isPlatformOrg(contextOrg || {}) && (
          <Tabs.TabPane
            tab={`Marketplace Network ${
              marketplaceNetworksForOrgId
                ? `(for ${
                    orgs.find((o) => o.id === marketplaceNetworksForOrgId)
                      ?.name || ''
                  })`
                : ''
            }`}
            key="3"
            disabled={marketplaceNetworksForOrgId === undefined}
            active={marketplaceNetworksForOrgId !== undefined}
          >
            <MarketplaceNetworkMemberTable />
          </Tabs.TabPane>
        )}
      </Tabs>
    </>
  );
};

export default NetworkAdmin;
